<form [formGroup]="descriptionForm">
  <mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'asset-description'">
    <mat-card-header class="detail-card-header">
      <mat-card-title data-test="title">Company Description</mat-card-title>
    </mat-card-header>
    <mat-card-subtitle>
      @if ((gptDescription$ | async)?.status === 'ERROR') {
        <valumize-info-panel [appearance]="'ERROR'" [message]="gptErrorMessage"></valumize-info-panel>
      }
    </mat-card-subtitle>
    <ng-container>
      <mat-card-content class="detail-card-content">
        <div class="company-description-form">
          <div class="logo-and-url">
            @if (!description.assetDescriptionIsEditable) {
              <a [href]="validateUrl(description.url.text)" class="btn btn-link url" data-test="website" rel="noopener"
                target="_blank">
                {{description.url.text}}
              </a>
            }
            @if (description.assetDescriptionIsEditable) {
              <mat-form-field appearance="fill" class="url">
                <input data-test="asset-url"
                  formControlName="assetUrl"
                  matInput
                  placeholder="Website"
                  [errorStateMatcher]="urlErrorMatcher">
                <button matSuffix mat-icon-button (click)="searchWebsite()"
                  type="button" aria-label="Search for website"
                  matTooltip="Search for company website">
                  <mat-icon>search</mat-icon>
                </button>
                @if (descriptionForm.controls.assetUrl.hasError('pattern')) {
                  <mat-error>Please enter a valid website (e.g., www.example.com)</mat-error>
                }
              </mat-form-field>
            }
          </div>
          <div class="description-section">
            @if (!description.assetDescriptionIsEditable && description.description.text) {
              <div class="description line-breaks">
                {{description.description.text}}
              </div>
            } @else {
              @if (!description.assetDescriptionIsEditable) {
                <div class="no-description" style="color: grey">
                  Please add a company description!
                </div>
              }
            }
            @if (description.assetDescriptionIsEditable) {
              <div class="description-container">
                <mat-form-field appearance="fill" class="description">
                  <textarea class="line-breaks"
                    data-test="description"
                    formControlName="assetDescription"
                  matInput></textarea>
                </mat-form-field>
                @if (gptDescription$ | async; as gptDescription) {
                  @if (isGptEditMode && gptDescription.status !== 'LOADING') {
                    <div class="gpt-actions">
                      <button mat-stroked-button color="primary" (click)="copyGptDescription(gptDescription.data)">Replace</button>
                      <button mat-stroked-button color="primary" (click)="addGptDescription(gptDescription.data)">Append</button>
                    </div>
                  }
                }
                @if (isGptEditMode && (gptDescription$ | async)?.status !== 'LOADING') {
                  <mat-form-field appearance="fill" class="description">
                    <textarea class="line-breaks"
                      [value]="(gptDescription$ | async)?.data?.text || ''"
                      matInput
                    readonly></textarea>
                  </mat-form-field>
                }
              </div>
            }
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions class="detail-card-actions">
        @if ((gptDescription$ | async)?.status === 'LOADING') {
          <mat-spinner diameter="24"></mat-spinner>
        }
        @if (description.assetDescriptionIsEditable) {
          <span [matTooltip]="!hasWebsiteUrl ? 'Please fill in the website first' : ''">
            <button mat-icon-button
              (click)="isGptEditMode ? gptCancel() : gptEditMode()"
              [disabled]="!hasWebsiteUrl"
              class="image-button"
              aria-label="Generate Description">
              <img src="assets/logo.svg" alt="Valumize AI" />
            </button>
          </span>
        }
        <div class="last-modified" data-test="modification-date">Last modified: {{description.description.modDate | timestamp}}</div>
        @if (!description.assetDescriptionIsEditable) {
          <button (click)="editMode()"
            [disabled]="(isEditDisabled$ | async)!"
            color="primary"
            data-test="edit-button"
            mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
        }
        @if (description.assetDescriptionIsEditable) {
          <button (click)="save(); gptCancel()"
            [disabled]="descriptionForm.invalid"
            color="primary"
            data-test="save-button"
            mat-icon-button>
            <mat-icon>save</mat-icon>
          </button>
        }
        @if (description.assetDescriptionIsEditable) {
          <button (click)="cancel(); gptCancel()" color="primary" data-test="cancel-button" mat-icon-button>
            <mat-icon>cancel</mat-icon>
          </button>
        }
        <valumize-card-comments-button [commentSlug]="'asset-description'"></valumize-card-comments-button>
      </mat-card-actions>
    </ng-container>
  </mat-card>
</form>
